// extracted by mini-css-extract-plugin
export default {"content":"Main_content__MMeLg","addNewButtonContainer":"Main_addNewButtonContainer__qtp7N","addNewButton":"Main_addNewButton__d9n2Z"};